
export const notificationTypes = {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success',
};